import { h, mergeProps } from 'vue'
import { Icon, addCollection } from '@iconify/vue'
import collections from './collections.js'
import pageAliases from './pageAliases.js'
import vuetifyAliases from './vuetifyAliases.js'

for (const collection of collections) addCollection(collection)

function stripMdi(name) {
  return !name || typeof name !== 'string' ? '' : name.replace(/^mdi-/, '').trim()
}

export function resolveNrIcon(name) {
  if (!name || typeof name !== 'string') return 'fa6-solid:circle-question'
  if (name.includes(':') && !name.startsWith('mdi-')) return name
  if (vuetifyAliases[name]) return vuetifyAliases[name]
  const stripped = stripMdi(name)
  if (vuetifyAliases[stripped]) return vuetifyAliases[stripped]
  if (pageAliases[stripped]) return pageAliases[stripped]
  return `fa6-solid:${stripped || 'circle-question'}`
}

export const iconifySet = {
  component: {
    name: 'IconifyIcon',
    inheritAttrs: false,
    props: {
      icon: { type: [String, Object, Function], required: true },
      tag: { type: String, default: 'span' },
    },
    setup(props, { attrs }) {
      return () => {
        if (typeof props.icon !== 'string') {
          return h(props.icon, mergeProps(attrs, { class: 'nr-icon' }))
        }
        return h(Icon, mergeProps(attrs, {
          icon: resolveNrIcon(props.icon),
          class: 'nr-icon nr-icon--iconify',
          width: '1em',
          height: '1em',
          inline: false,
          'aria-hidden': attrs['aria-hidden'] ?? 'true',
        }))
      }
    },
  },
}

export const iconAliases = { ...vuetifyAliases }
